import {errorHandler, message, logout, loader, getCountryByCode, getNewCount, copyElement, getCatalogId, updatePageTitle, getTruncatedTwitterUrl, openInNewTab} from '@/libs/helper'
import {getDetails, followUnfollow, getArticlesCount, getCollectionDossierCount, collectionFilterData, getCollectionInfo, getDossierInfo, dossierFilterData, createShortUrl, getShortUrl, getRegisteredList, followCollection, getAuthorFilterData, getPublicationFilterData, getFollowersCount, updateFavourite, checkStripeAccountStatus, getUserFollowersCount} from '@/libs/api/api'
import constants from '@/libs/constant/constants'
import pageRoute from '@/libs/constant/pageRoutes'
import {sortBy, cloneDeep, isEmpty} from 'lodash'

export default {
    components: {
        'ShareMessage': () => import('@/components/component/Reuse/ShareMessage/ShareMessage.vue'),
        donatePopup: () => import('@/components/component/Reuse/DonateDialog/DonateDialog.vue')
    },
    props: {
        activateSharePopup: {
            type: Function,
            default: () => {}
        },
        handleClose: {
            type: Function,
            default: () => {}
        },
        updateArticleShareCount: {
            type: Object,
            default: () => {}
        },
        changeUpdateArticleShareCount: {
            type: Function,
            default: () => {}
        }
    },
    created() {
        if (this.$route.path && this.$route.path.includes('/publications')) {
            this.module = 'PUBLICATION'
        }
        if (this.$route.path && this.$route.path.includes('/authors')) {
            this.module = 'AUTHOR'
        }
        if (this.$route.path && this.$route.path.includes('/publishers')) {
            this.module = 'PUBLISHER'
        }        
        this.setPageType(this.$route, true)
    },
    mounted(){
        this.fetchMetaDetails()
    },
    watch: {
        '$route' (to, from) {
            if (to.params && to.params.id && from.params && from.params.id && to.params.id !== from.params.id) {
                this.fetchMetaDetails()
            }             
            this.setPageType(to)
        }
    },
    computed: {
        isSettingsTab () {
            if (this.$route.name === 'author-locations' || this.$route.name === 'publication-locations' || this.$route.name === 'publisher-locations') return true
            return false
        }
    },
    data(){
        return {
            openInNewTab,
            getTruncatedTwitterUrl,
            copyElement,
            isEmpty,
            getNewCount,
            details: {},
            counts:[],
            module: '',
            getCountryByCode: getCountryByCode,
            activeName: 'zero',
            articles: [],
            articlesToDisplay: [],
            sortAs: 'Most recent',
            viewKey: 1,
            shortUrl: '',
            collectionShortUrl: '',
            showDropdown: false,
            isCollection: false,
            isArticles: false,
            isDossier: false,
            selectedRecord: {},
            isSettings: false,
            manageList: {},
            selectedValue: '',
            activeMenu: 'Profile',
            articlesCount: 0,
            collectionCount: 0,
            followersCount: 0,
            collectionFollowersCount: 0,
            dossierCount: 0,
            collectionArticleCount: 0,
            isUpdateFollowers: false,
            isShare: false,
            articleToShare: {},
            shareType: '',
            // updateArticleShareCount: {},
            showDonate: false,
            aboutPageClicked: '',
            stripeAccountDetails: {},
            followingList: []
        }
    },
    methods:{
        getIconClassName(media){
            switch (media.type){
                case 'TWITTER':
                    return 'nova-twitter-icon'
                case 'FACEBOOK':
                    return 'nova-facebook'
                case 'LINKEDIN':
                    return 'nova-linkedin'
                case 'PARLER': 
                   return  'nova-parler-icon'
            }
        },
        /**
         * method to hit all the api's t get initial data
         */
        fetchMetaDetails () {
            console.log('res234')
            // module details
            this.fetchDetails()
            
            // article count
            this.getArticlesCount()
            
            // collection count
            this.getCollectionCount()
            
            // dossier count
            this.getCollectionCount(true)
            
            // followers count
            this.getmetaFollowersCount()

            // followers list
            this.getmetaFollowersList()
        },
        fetchDetails(){
            getDetails(this.module.toLowerCase(), this.$route.params.id).then(async(response) => {
                console.log('res', response)
                this.details = response
                // to update the page title
                updatePageTitle(`Newsroom | ${response.name}`)
                // to get the sorted results
                this.getSortedMetaFilters(this.module)
                // to get the short url of the detail page
                this.getDetailShortUrl()
                // if settings tab is selected
                if (this.isSettings) this.getSettings()
            }).catch((error)=>{
                console.error('error', error);
            })
        },
        /**
         * to get the sorted author/publications
         */
        getSortedMetaFilters: async function (module) {
            let response;
            switch (module) {
                case constants.PUBLICATION.key:
                   response = await getPublicationFilterData({publication_id: this.$route.params.id})
                   this.$set(this.details, 'authors', response.authors || [])
                break
                case constants.AUTHOR.key:
                    response = await getAuthorFilterData({author_id: this.$route.params.id})
                    this.$set(this.details, 'publications', response.publications || [])
                break
            }
            // to get the following details of user
            this.getUserFollowingDetails(response)
        },
        /**
         * to get the following details of the user
         */
        getUserFollowingDetails (data) {
            try {
                let details = cloneDeep(this.details)
                if(data && details.authors && !isEmpty(details.authors)) {
                    details.authors = details.authors.map(author => {
                        author.is_following = false
                        if (data.followings && data.followings.author_following && !isEmpty(data.followings.author_following) && new Set(data.followings.author_following).has(author._id)) author.is_following = true
                        return author
                    })
                    this.$set(this.details, 'authors', details.authors || [])
                }
                if (data && details.publications && !isEmpty(details.publications)) {
                    details.publications = details.publications.map(publication => {
                        publication.is_following = false
                        if (data.followings && data.followings.publication_following && !isEmpty(data.followings.publication_following) && new Set(data.followings.publication_following).has(publication._id)) publication.is_following = true
                        return publication
                    })
                    this.$set(this.details, 'publications', details.publications || [])
                }
            } catch (error) {
                console.error(error)
            }
        },
        /**
         * route to detail page of A/P/P
         * @param {*} record 
         * @param {*} type 
         */
        routeToDetailPage(record, type){
            this.$router.push(`/ip/${type.toLowerCase()}s/${record.publication || record._id}/`).catch(() => {})
        },
        /**
         * route to detail page of A/P/P
         */
        routeFromCollectionPage (record, type) {
            this.$router.push(`/ip/${type.toLowerCase()}s/${record.author_id || record.publication_id || record.publisher_id}/`).catch(() => {})
        },
        followUnfollowAction(module, details){
            if(details.is_admin){
                message(this, constants.messageType.WARNING, ('Managed author cannot be unfollowed'))
                return
            }

            loader(this, true)

            let body = {
                id: details._id
            }
            followUnfollow(body, details.is_following ? 'unfollow' : 'follow', this.module.toLowerCase())
                .then(()=>{
                    this.getmetaFollowersCount()
                    this.getmetaFollowersList()
                    if(details.is_following) message(this, constants.messageType.SUCCESS, 'Unfollowed Successfully');
                    this.details.is_following = !details.is_following
                    // to update the listing of the followers
                    if (this.$route.name === 'author-about' || this.$route.name === 'publication-about' || this.$route.name === 'publisher-about' ) this.changeUpdateFollowers(true)
                    this.updateStoreListing(module, details, details.is_following)
                    loader(this, false)
                })
                .catch((error)=>{
                    console.error('--', error)
                    loader(this, false)
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                })
        },
        /*
         * returns the user to fetch the user's avatar.
         * */
        getURL(imageName){
            return `${process.env.VUE_APP_API_BASE_URL}/accounts/files/${imageName}?auth=${localStorage.getItem('accuraAuthToken')}`
        },
        /*
         * return the place holder image in case of error in image loading.
         * */
        onError(e) {
            let avatarURL = require('@/assets/images/author_placeholder.png');
            if (e.target.src !== avatarURL) {
                e.target.src = avatarURL;
            }
        },
        updateStoreListing(module, item, isFollow){
            let authorsFollowings = cloneDeep(this.$store.getters.getUserFollowings.author || [])
            let publisherFollowings = cloneDeep(this.$store.getters.getUserFollowings.publisher || [])
            let publicationFollowings = cloneDeep(this.$store.getters.getUserFollowings.publication || [])
            switch (module){
                case constants.AUTHOR.key:
                    
                    if(isFollow){
                        item.type = module
                        authorsFollowings.push(cloneDeep(item))
                    }else{
                        authorsFollowings = authorsFollowings.filter(af => af._id !== item._id)
                    }
                    this.$store.dispatch('updateUserFollowingsAuthorToStore', sortBy(authorsFollowings, 'name'))
                    break
                case constants.PUBLISHER.key:
                    
                    if(isFollow){
                        item.type = module
                        publisherFollowings.push(cloneDeep(item))
                    }else{
                        publisherFollowings = publisherFollowings.filter(af => af._id !== item._id)
                    }
                    this.$store.dispatch('updateUserFollowingsPublisherToStore', sortBy(publisherFollowings, 'name'))
                    break
                case constants.PUBLICATION.key:
                    
                    if(isFollow){
                        item.type = module
                        publicationFollowings.push(cloneDeep(item))
                    }else{
                        publicationFollowings = publicationFollowings.filter(af => af._id !== item._id)
                    }
                    this.$store.dispatch('updateUserFollowingsPublicationToStore', sortBy(publicationFollowings, 'name'))
                    break
            }
        },
        openExternalURL (url) {
            url = this.getAddress(url)
            window.open(url, '_blank')
        },
        getAddress (url) {
            if (url === null || url ===undefined) return
            if (!url.includes('https://' || 'http://')) url = 'https://'+ url
            return url
        },
        sort () {
        },

        /**
         * clicked when tab is changed
         * @param {*} tab 
         */
        handleClick() {
        },

        /**
         * to get the count of articles
         */
        getArticlesCount () {
            // body
            let body = {
                type: this.module,
                entity_id: this.$route.params.id
            }
            // api call
            getArticlesCount(body).then(response => {
                this.articlesCount = response.count || 0
            }).catch(error => error)
        },

        /**
         * to get the count of collection
         */
        getCollectionCount (isDossier) {
            // body for api
            let body = {
                entity_id: this.$route.params.id,
                entity_type: this.module,
                count_for: 'COLLECTION'
            }
            if (isDossier) body.count_for = 'DOSSIER'
            // api call
            getCollectionDossierCount(body).then(response => {
                if (isDossier) this.dossierCount = (response.count || 0)
                else this.collectionCount = (response.count || 0)
            }).catch(error => error)
        },

        /**
         * route to author detail page 
         */
        routeToAboutPage (query) {
            this.$router.push({name: `${this.module.toLowerCase()}-about`}).catch(() => {})
            this.aboutPageClicked = query
        },

        resetAboutPageClicked () {
            this.aboutPageClicked = ''
        },
        /**
         * route to collection about page
         */
        routeToCollectionAboutPage (query) {
            if (this.isDossier) {
                if (query !== '' && query !== null && query !== undefined) {
                    this.$router.push({name: `${this.module.toLowerCase()}-dossier-about-page`, query: {type: query}}).catch(() => {})
                } else {
                    this.$router.push({name: `${this.module.toLowerCase()}-dossier-about-page`}).catch(() => {})
                }
            } else {
                if (query !== '' && query !== null && query !== undefined) {
                    this.$router.push({name: `${this.module.toLowerCase()}-collection-about-page`, query: {type: query}}).catch(() => {})
                } else {
                    this.$router.push({name: `${this.module.toLowerCase()}-collection-about-page`}).catch(() => {})
                }
            }
            
        },

        /**
         * update article count whenever page 
         * lands on article page > latest tab
         */
        updateArticleCount (count) {
            // update articles count
            if (count !== undefined && count !== null) this.articlesCount = count
        },
        /**
         * update the router key to route on the same route
         */
        updateViewKey () {
            this.viewKey +=1
        },
        /**
         * to update the left side menu
         * @param {*} isCollection true for collection 
         * and false for dossier
         * @param {*} item item to show
         */
        updateLeftMenu (isCollection, item) {
            this.selectedRecord = cloneDeep(item)
            this.isCollection = true
            if (isCollection) {
                this.getCollectionFilterData()
            } 
            else if (!isCollection) {
                this.getDossierFilterData()
            }
        },
        /**
         * to get the collection filter data
         */
        getCollectionFilterData:async function (isTrue) {
            try {
                // to get the short url
                this.getShortUrlCollection()
                // to get the followers count
                this.getCollectionDossierFollowersCount()
                let cid = this.$route.params.cid
                if (isTrue) {
                    let result = await getCollectionInfo(cid)
                    this.selectedRecord = result
                }
                let response = await collectionFilterData({collection_id: cid})
                // this.$set(this.selectedRecord, 'authors', response.authors|| [])
                // this.$set(this.selectedRecord, 'publications', response.publications|| [])
                // this.$set(this.selectedRecord, 'publishers', response.publishers|| [])
                this.setCollectionFilterData(response)
            } catch (error) {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            }
        },
        /**
         * to set the filter data
         * @param {*} data 
         */
        setCollectionFilterData (data) {
            // to set is_following key of authors
            if (data && data.authors && !isEmpty(data.authors)) {
                data.authors = data.authors.map(author => {
                    author.is_following = false
                    if (data.followings && data.followings.author_following && !isEmpty(data.followings.author_following) && new Set(data.followings.author_following).has(author.author_id)) author.is_following = true
                    return author
                })
                this.$set(this.selectedRecord, 'authors', data.authors || [])
            }
            // to set is_following for publications
            if (data && data.publications && !isEmpty(data.publications)) {
                data.publications = data.publications.map(publication => {
                    publication.is_following = false
                    if (data.followings && data.followings.publication_following && !isEmpty(data.followings.publication_following) && new Set(data.followings.publication_following).has(publication.publication_id)) publication.is_following = true
                    return publication
                })
                this.$set(this.selectedRecord, 'publications', data.publications || [])
            }
            // to set is_following for publishers
            if (data && data.publishers && !isEmpty(data.publishers)) {
                data.publishers = data.publishers.map(publisher => {
                    publisher.is_following = false
                    if (data.followings && data.followings.publisher_following && !isEmpty(data.followings.publisher_following) && new Set(data.followings.publisher_following).has(publisher.publisher_id)) publisher.is_following = true
                    return publisher
                })
                this.$set(this.selectedRecord, 'publishers', data.publishers || [])
            }
        },
        /**
         * to get the collection filter data
         */
        getDossierFilterData:async function (isTrue) {
            try {
                this.isDossier = true
                // to get the short url
                this.getShortUrlCollection()
                // to get the followers count
                this.getCollectionDossierFollowersCount()
                let did = this.$route.params.did
                if (isTrue) {
                    let result = await getDossierInfo(did)
                    this.selectedRecord = result
                }
                let response = await dossierFilterData({dossier_id: did})
                this.$set(this.selectedRecord, 'authors', response.authors|| [])
                this.$set(this.selectedRecord, 'publications', response.publications|| [])
                this.$set(this.selectedRecord, 'publishers', response.publishers|| [])
                this.setCollectionFilterData(response)
                } catch (error) {
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                }
        },
        changeMenu (menu) {
            this.activeMenu = menu
        },
        changeSettingsTab () {
            
        },
        /**
         * to get the settings
         */
        getSettings () {
            this.isSettings = true
            this.selectedValue = {
                name: this.details.name,
                _id: this.$route.params.id
            }
            getRegisteredList({})
            .then((response)=> {
                this.$set(this.manageList, 'authors', sortBy(response.items.AUTHOR || [], 'name'))
                this.$set(this.manageList, 'publications', sortBy(response.items.PUBLICATION || [], 'name'))
                this.$set(this.manageList, 'publishers', sortBy(response.items.PUBLISHER || [], 'name'))
            }).catch((error)=> {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            })
        },
        /**
         * to refresh the left side menu
         */
        refreshMenu () {
            this.isSettings = false
            this.isCollection = false
            this.isDossier = false
            this.isArticles = false
        },
        /**
         * to update the meta listing when author/publication is followed
         * @param {*} meta 
         * @param {*} type 
         */
        updateMetaList (meta, type) {
            switch (type) {
                case constants.AUTHOR.key:
                    this.details.authors = this.details.authors.map(author => {
                        if (author._id === meta._id) author.is_following = meta.is_following
                        return author
                    })
                break
                case constants.PUBLICATION.key:
                    this.details.publications = this.details.publications.map(publication => {
                        if (publication._id === meta._id) publication.is_following = meta.is_following
                        return publication
                    })
                break
            }
        },
        /**
         * to update the count of 
         * @param {*} meta 
         * @param {*} type 
         */
        updateCollectionMetaList (meta, type) {
            // if result matches the detal page of A/P/P then update the is_folllow
            if (meta.data && meta.data._id === this.details._id) {
                this.details.is_following = meta.is_following
            }
            switch (type) {
                case constants.AUTHOR.key:
                    this.selectedRecord.authors = this.selectedRecord.authors.map(author => {
                        if (meta.data && meta.data._id === author._id) author.is_following = meta.is_following
                        return author
                    })
                break
                case constants.PUBLICATION.key:
                    this.selectedRecord.publications = this.selectedRecord.publications.map(publication => {
                        if (meta.data && meta.data._id === publication._id) publication.is_following = meta.is_following
                        return publication
                    })
                break
                case constants.PUBLISHER.key:
                    this.selectedRecord.publishers = this.selectedRecord.publishers.map(publisher => {
                        if (meta.data && meta.data._id === publisher._id) publisher.is_following = meta.is_following
                        return publisher
                    })
                break
            }
        },
        
        /**
         * to create the short url of detail page
         */
        createDetailShortUrl () {
            // body
            let body = {
                type: this.module,
                type_id: this.$route.params.id,
            }
            // api call
            createShortUrl(body).then(response => {
                this.shortUrl = response.short_url || ''
            }).catch(error => {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            })
        },

        /**
         * to get the short url of detail page
         */
        getDetailShortUrl () {
            // body for api call
            let body = {
                type: this.module,
                type_id: this.$route.params.id,
              }
            // api call
            getShortUrl(body).then(response => {
                this.shortUrl = response.short_url || ''
            }).catch(error => {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            })
        },

        /**
         * api call to get the collection/dossier short url
         */
        getShortUrlCollection (isCreate) {
            // body for api call
            let body = {
                type: 'COLLECTION',
                type_id: this.$route.params.cid,
                sub_type: this.module,
                sub_type_id: this.$route.params.id,
                user: this.$store.getters.getUserInformation.id
            }
            if (this.isDossier) {
                body.type = 'DOSSIER'
                body.type_id = this.$route.params.did
            }
            // short url is create 
            if (isCreate) {
                // api call
                createShortUrl(body).then(response => {
                    this.collectionShortUrl = response.short_url || ''
                }).catch(error => {
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                })
            }
            // to get short url
            else {
                // api call
                getShortUrl(body).then(response => {
                    this.collectionShortUrl = response.short_url || ''
                }).catch(error => {
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                })
            }
        },
        /**
         * to update the detail info on 
         */
        updateDetailInfoOnEdit (type, data) {
            let details = cloneDeep(this.details)
            switch (type) {
                case 'NAME':
                    details.first_name = data.first_name
                    details.last_name = data.last_name
                    details.name = data.name
                    details.middle_name = data.middle_name
                    details.screen_name = data.screen_name
                    if (this.module === constants.AUTHOR.key) details.url = data.website
                    else if (this.module === constants.PUBLISHER.key) {
                        details.registration_number = data.registration_number
                        details.url = data.url
                    }
                    else if (this.module === constants.PUBLICATION.key) details.language = data.language
                    this.updateSettingsDropdown(details)
                break
                case 'DESCRIPTION':
                    details.short_description = data.short_description
                    details.biography = data.biography
                break
                case 'MANANGING_RIGHTS':
                    details.managing_editor = data.managing_editor
                break
                case 'ADDRESS':
                    details.address = data.address
                    if (this.module === constants.PUBLISHER.key) details.contact_detail = data.contact_detail
                break
                case 'SOCIAL_MEDIA':
                    details.social_media = data.social_media
                break
                case 'IMAGE':
                    details.avatar_image = data.avatar_image
                break
            }
            this.details = details
        },
        /**
         * update the dropdown values
         */
        updateSettingsDropdown (data) {
            // update selected value
            this.selectedValue.name = data.name
            let authors = cloneDeep(this.manageList.authors)
            let publishers = cloneDeep(this.manageList.publishers)
            let publications = cloneDeep(this.manageList.publications)
            switch (this.module) {
                // update authors
                case constants.AUTHOR.key:
                    
                    authors.map(author => {
                        if (author._id === data._id) author.name = data.name
                        return author
                    })
                    this.manageList.authors = authors
                break
                // update publishers
                case constants.PUBLISHER.key:
                    
                    publishers.map(publisher => {
                        if (publisher._id === data._id) publisher.name = data.name
                        return publisher
                    })
                    this.manageList.publishers = publishers
                break
                // update publications
                case constants.PUBLICATION.key:
                    
                    publications.map(publication => {
                        if (publication._id === data._id) publication.name = data.name
                        return publication
                    })
                    this.manageList.publications = publications
                break
            }
        },

        /**
         * to follow the collection/dossier
         */
        followCollection (isDossier) {
            loader(this, true)
            // body for api
            let body = {
                entity_type: constants.LIST.COLLECTION,
                entity_id: this.$route.params.cid,
                catalog_id: getCatalogId()
            }
            if (isDossier || this.isDossier) {
                body.entity_id = this.$route.params.did
                body.entity_type = constants.LIST.DOSSIER
            }
            // api call
            followCollection(body, this.selectedRecord.is_following ? 'unfollow' : 'follow').then(() => {
                this.getCollectionDossierFollowersCount()
                message(this, constants.messageType.SUCCESS, `${this.selectedRecord.is_following ? ('Unfollowed Successfully') : ('Followed Successfully')}`);
                this.selectedRecord.is_following = !this.selectedRecord.is_following
                // about internal page is active then update the list of followers
                if (this.$route.name === 'author-collections-page' || this.$route.name === 'publication-collections-page' || this.$route.name === 'publisher-collections-page' || this.$route.name === 'author-collection-about-page' || this.$route.name === 'publication-collection-about-page' || this.$route.name === 'publisher-collection-about-page') this.changeUpdateFollowers(true)
                loader(this, false)
            }).catch(error => {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                loader(this, false)
            })
        },
        /**
         * to get the count of followers of detail page 
         */
        getmetaFollowersCount () {
            // body for api
            let body = {
                entity_type: this.module,
                entity_id: this.$route.params.id
            }
            // api call
            getFollowersCount(body).then(response => {
                this.followersCount = response.count || 0
            }).catch(error => {
                console.error('++', error)
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            })
        },

        /**
         * to get the list of followers of detail page 
         */
        getmetaFollowersList () {
            // body for api
            let body = {
                entity_type: this.module,
                entity_id: this.$route.params.id
            }
            // api call
            getUserFollowersCount(body).then(response => {
                this.followingList = response.users || []
            }).catch(error => {
                console.error(error)
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            })
        },

        /**
         * to get the count of followers of collection/dossier
         */
        getCollectionDossierFollowersCount () {
            // body for api
            let body = {
                entity_type: this.isDossier ? constants.LIST.DOSSIER : constants.LIST.COLLECTION,
                entity_id: this.isDossier ? this.$route.params.did : this.$route.params.cid
            }
            // api call
            getFollowersCount(body).then(response => {
                this.collectionFollowersCount = response.count || 0
            }).catch(error => {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            })
        },

        /*
         * to route to collection page
         */
        routeToCollectionPage () {
            // route to dossier
            if (this.isDossier) this.$router.push({name: `${this.module.toLowerCase()}-dossiers`}).catch(() => {})
            // route to collection
            else this.$router.push({name: `${this.module.toLowerCase()}-collections`}).catch(() => {})
            // to refresh the menu
            this.refreshMenu()
        },
        /**
         * to update the count of followers
         * @param {*} item 
         */
        updateCount (type, item) {
            switch (type) {
                case constants.LIST.COLLECTION:
                    this.collectionFollowersCount = item.count || 0
                break
                case constants.LIST.COLLECTION_ARTICLES:
                    this.collectionArticleCount = item
                break
            }  
        },
        /**
         * route to about page
         * @param {*} query where to route
         * @param {*} isCollection iscollection true/false
         */
        routeToFollowers (query, isCollection) {
            if (isCollection) {
                let name = this.isDossier ? `${this.module.toLowerCase()}-dossier-about-page` : `${this.module.toLowerCase()}-collection-about-page`
                this.$router.push({name: name, query: {type: query}}).catch(() => {})
            } else {
                this.$router.push({name: `${this.module.toLowerCase()}-about`, query: {type: query}}).catch(() => {})
            }
        },
        /**
         * to update the isUpdateFollowers
         */
        changeUpdateFollowers (isTrue) {
            this.isUpdateFollowers = isTrue
        },

        /**
         * to create star for Author/publisher/publication
         */
        async setFavourite () {
            try {
                loader(this, true)
                // body for api
                let isRemove = this.getFavorite()
                let body = {
                    entity_type: this.module,
                    entity_id: this.$route.params.id
                }
                // api call
                let response = await updateFavourite(body, isRemove ? 'remove-favorite' : 'favorite')
                this.$set(this.details, 'favorites', response.result.favorites || [])
                message(this, constants.messageType.SUCCESS, !isRemove ? 'marked_favorite' : 'removed_favorite')
                loader(this, false)
            } catch (error) {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                loader(this, false)
            }
        },
        /**
         * to get the favorite for A/P/P and collection/dossier
         * @param {*} isCollection true(to check for collection/dossier) 
         */
        getFavorite (isCollection) {
            // to check for collection/dossier
            if (isCollection && this.selectedRecord && this.selectedRecord.favorites && new Set(this.selectedRecord.favorites).has(this.$store.getters.getUserInformation.id)) return true
            // to check for detail page(A/P/P)
            else if (!isCollection && this.details && this.details.favorites && new Set(this.details.favorites).has(this.$store.getters.getUserInformation.id)) return true
            else return false
        },

        /**
         * create/delete favorite for collection and dossier
         */
        async setCollectionFavorite () {
            try {
                loader(this, true)
                // body for api
                let isRemove = this.getFavorite(true)
                let body = {
                    entity_type: this.isDossier ? constants.LIST.DOSSIER : constants.LIST.COLLECTION,
                    entity_id: this.$route.params.cid
                }
                // api call
                let response = await updateFavourite(body, isRemove ? 'remove-favorite' : 'favorite')
                this.$set(this.selectedRecord, 'favorites', response.result.favorites || [])
                message(this, constants.messageType.SUCCESS, !isRemove ? 'marked_favorite' : 'removed_favorite')
                loader(this, false)
            } catch (error) {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                loader(this, false)
            }
        },
        /**
         * to set the the type of page is selected on 
         * which designs are selected for pages
         * @param {*} route route.name
         */
        setPageType (route, isCalledFromCreatedHook) {
            this.isArticles = false
            // for settings page
            if (route.name === pageRoute.authorSettings || route.name === pageRoute.publisherSettings || route.name === pageRoute.publicationSettings) {
                this.isSettings = true
            }

            // articles page
            else if (route.name === pageRoute.publicationArticles || route.name === pageRoute.authorArticles || route.name === pageRoute.publisherArticles) {
                this.isArticles = true
            }

            // for collection articles page
            else if (route.name === pageRoute.authorCollectionPage || route.name === pageRoute.publicationCollectionPage || route.name === pageRoute.publisherCollectionPage) {
                this.isCollection = true
                this.isArticles = true
                if (isCalledFromCreatedHook) this.getCollectionFilterData(true)
            }

            // about page of collection
            else if (route.name === pageRoute.authorCollectionAboutPage || route.name === pageRoute.publicationCollectionAboutPage || route.name === pageRoute.publisherCollectionAboutPage) {
                this.isCollection = true
                if (isCalledFromCreatedHook) this.getCollectionFilterData(true)
            }
            
            // for dossier article page
            else if (route.name === pageRoute.authorDossierPage || route.name === pageRoute.publicationDossierPage || route.name === pageRoute.publisherDossierPage) {
                this.isCollection = true
                this.isDossier = true
                this.isArticles = true
                if (isCalledFromCreatedHook) this.getDossierFilterData(true)
            }

            // for dossier about page
            else if (route.name === pageRoute.authorDossierAboutPage || route.name === pageRoute.publicationDossierAboutPage || route.name === pageRoute.publisherDossierAboutPage) {
                this.isCollection = true
                this.isDossier = true
                if (isCalledFromCreatedHook) this.getDossierFilterData(true)
            }
            
            // to refresh menu if noting matches
            else {
                this.refreshMenu()
                
            }
        },
        /**
         * to close the donate popup
         */
        async showDonatePopup () {
            try {
                loader(this, true)
                // body for api
                let body = {
                    entity_type: this.module,
                    entity_id: this.$route.params.id
                }
                // api call
                let response = await checkStripeAccountStatus(body)
                // set account status
                this.stripeAccountDetails = response || {}
                if (!response.details_submitted) {
                    message(this, constants.messageType.ERROR, 'Connected account details not submitted')
                } else {
                    // open donate popup
                    this.showDonate = true
                }
            } catch (error) {
                console.error(error)
            } finally {
                loader(this, false)
            }
        },
        /**
         * to close donate popup
         */
        closeDonatePopup () {
            this.showDonate = false
        }
    }
}